module.exports = __webpack_public_path__ + "static/media/home_banner.3b8cda58.png";